(() => {
  const TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

  function init(root = document) {
    root.querySelectorAll('[data-product-image-upload]:not([data-upload-ready])').forEach((field) => {
      field.dataset.uploadReady = 'true';
      const input = field.querySelector('[data-upload-input]');
      const box = field.querySelector('[data-upload-box]');
      const previews = field.querySelector('[data-upload-previews]');
      const properties = field.querySelector('[data-upload-properties]');
      const empty = field.querySelector('[data-upload-empty]');
      const more = field.querySelector('[data-upload-more]');
      const status = field.querySelector('[data-upload-status]');
      const form = field.closest('form');
      if (!input || !box || !previews || !properties || !form) return;

      const cloudName = field.dataset.cloudName || '';
      const preset = field.dataset.uploadPreset || '';
      const propertyName = field.dataset.propertyName || 'Custom image';
      const required = field.dataset.required === 'true';
      const maxImages = Math.max(1, parseInt(field.dataset.maxImages || '8', 10));
      const maxBytes = (parseFloat(field.dataset.maxFileSize || '5') || 5) * 1024 * 1024;
      const uploadUrl = `https://api.cloudinary.com/v1_1/${encodeURIComponent(cloudName)}/image/upload`;
      let files = [];

      const submissionState = () => ({
        uploading: files.some((file) => file.state === 'uploading'),
        uploaded: files.filter((file) => file.state === 'uploaded').length,
        failed: files.some((file) => file.state === 'error')
      });

      function updateButtons() {
        const state = submissionState();
        const blocked = state.uploading || state.failed || (required && state.uploaded === 0);
        form.querySelectorAll('[type="submit"], [name="add"]').forEach((button) => {
          if (blocked && !button.disabled) {
            button.dataset.uploadDisabled = 'true';
            button.disabled = true;
          } else if (!blocked && button.dataset.uploadDisabled === 'true') {
            delete button.dataset.uploadDisabled;
            button.disabled = false;
          }
        });
      }

      function upload(file) {
        file.state = 'uploading';
        file.progress = 0;
        render();
        const body = new FormData();
        body.append('file', file);
        body.append('upload_preset', preset);
        const xhr = new XMLHttpRequest();
        file.xhr = xhr;
        xhr.open('POST', uploadUrl, true);
        xhr.timeout = 120000;
        xhr.upload.onprogress = (event) => {
          if (!event.lengthComputable) return;
          file.progress = Math.min(99, Math.round(event.loaded / event.total * 100));
          const progress = previews.querySelector(`[data-key="${file.key}"] [data-progress]`);
          if (progress) progress.textContent = `${file.progress}%`;
        };
        xhr.onload = () => {
          let data = {};
          try { data = JSON.parse(xhr.responseText); } catch (error) {}
          if (xhr.status >= 200 && xhr.status < 300 && data.secure_url) {
            file.state = 'uploaded';
            file.url = data.secure_url;
          } else {
            file.state = 'error';
            file.error = data.error?.message || 'Upload failed';
          }
          file.xhr = null;
          render();
        };
        xhr.onerror = () => { file.state = 'error'; file.error = 'Network error'; file.xhr = null; render(); };
        xhr.ontimeout = () => { file.state = 'error'; file.error = 'Upload timed out'; file.xhr = null; render(); };
        xhr.send(body);
      }

      function add(selected) {
        const rejected = [];
        Array.from(selected || []).forEach((file) => {
          if (files.length >= maxImages) return rejected.push(`You can upload up to ${maxImages} images`);
          if (!TYPES.includes(file.type)) return rejected.push(`${file.name} is not a supported image format`);
          if (file.size > maxBytes) return rejected.push(`${file.name} exceeds the file size limit`);
          if (files.some((item) => item.name === file.name && item.size === file.size && item.lastModified === file.lastModified)) return;
          file.key = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
          file.state = 'queued';
          file.previewUrl = URL.createObjectURL(file);
          files.push(file);
          upload(file);
        });
        if (rejected.length) {
          status.hidden = false;
          status.classList.add('is-error');
          status.textContent = [...new Set(rejected)].join('；');
        }
        render();
      }

      function render() {
        previews.innerHTML = '';
        properties.innerHTML = '';
        files.forEach((file, index) => {
          const item = document.createElement('div');
          item.className = 'product-image-upload__preview';
          item.dataset.key = file.key;
          const image = document.createElement('img');
          image.src = file.url || file.previewUrl;
          image.alt = file.name;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'product-image-upload__remove';
          remove.setAttribute('aria-label', `Remove ${file.name}`);
          remove.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
          remove.addEventListener('click', () => {
            if (file.xhr) file.xhr.abort();
            if (file.previewUrl) URL.revokeObjectURL(file.previewUrl);
            files.splice(index, 1);
            render();
          });
          const name = document.createElement('span');
          name.className = 'product-image-upload__name';
          name.textContent = file.name;
          item.append(image, remove, name);
          if (file.state === 'uploading' || file.state === 'queued') {
            const overlay = document.createElement('span');
            overlay.className = 'product-image-upload__overlay';
            overlay.innerHTML = `<span data-progress>${file.progress || 0}%</span><span>Uploading…</span>`;
            item.appendChild(overlay);
          } else if (file.state === 'error') {
            const overlay = document.createElement('span');
            overlay.className = 'product-image-upload__overlay product-image-upload__overlay--error';
            const message = document.createElement('span');
            message.textContent = file.error || 'Upload failed';
            const retry = document.createElement('button');
            retry.type = 'button';
            retry.className = 'product-image-upload__retry';
            retry.textContent = 'Retry';
            retry.addEventListener('click', (event) => { event.stopPropagation(); upload(file); });
            overlay.append(message, retry);
            item.appendChild(overlay);
          }
          previews.appendChild(item);
          if (file.state === 'uploaded' && file.url) {
            const property = document.createElement('input');
            property.type = 'hidden';
            property.name = `properties[${propertyName} ${properties.children.length + 1}]`;
            property.value = file.url;
            properties.appendChild(property);
          }
        });

        const state = submissionState();
        empty.hidden = files.length > 0;
        more.hidden = files.length === 0 || files.length >= maxImages;
        if (files.length) {
          status.hidden = false;
          status.classList.toggle('is-error', state.failed);
          status.textContent = state.uploading ? `Uploading images: ${state.uploaded}/${files.length}` : state.failed ? 'Some images failed to upload. Please retry or remove them.' : `${state.uploaded} ${state.uploaded === 1 ? 'image' : 'images'} uploaded successfully.`;
        } else {
          status.hidden = !required;
          status.classList.remove('is-error');
          status.textContent = required ? 'Please upload at least one image.' : '';
        }
        updateButtons();
      }

      if (!cloudName || !preset) {
        status.hidden = false;
        status.classList.add('is-error');
        status.textContent = 'Please enter the Cloudinary Cloud Name and Upload Preset in the theme editor.';
        return;
      }

      input.addEventListener('change', (event) => { add(event.target.files); input.value = ''; });
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((name) => box.addEventListener(name, (event) => { event.preventDefault(); event.stopPropagation(); }));
      ['dragenter', 'dragover'].forEach((name) => box.addEventListener(name, () => box.classList.add('is-dragging')));
      box.addEventListener('dragleave', () => box.classList.remove('is-dragging'));
      box.addEventListener('drop', (event) => { box.classList.remove('is-dragging'); add(event.dataTransfer?.files); });
      form.addEventListener('click', (event) => {
        const submit = event.target.closest('[type="submit"], [name="add"]');
        if (!submit || !form.contains(submit)) return;
        const state = submissionState();
        if (state.uploading || state.failed || (required && state.uploaded === 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          status.hidden = false;
          status.classList.add('is-error');
          status.textContent = state.uploading ? 'Your images are still uploading. Please wait.' : state.failed ? 'Please retry or remove the images that failed to upload.' : 'Please upload at least one image.';
        }
      }, true);
      form.addEventListener('submit', (event) => {
        const state = submissionState();
        if (state.uploading || state.failed || (required && state.uploaded === 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          status.hidden = false;
          status.classList.add('is-error');
          status.textContent = state.uploading ? 'Your images are still uploading. Please wait.' : state.failed ? 'Please retry or remove the images that failed to upload.' : 'Please upload at least one image.';
        }
      }, true);
      render();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => init(event.target));
})();
